import gql from 'graphql-tag'
import userFragment from './userFragment'

export const USER_QUERY = gql`
  query User {
    user {
      ...${userFragment}
    }
  }
`